'use client';
import { SearchViewModel } from '@api/index';
import { createGenericContext } from '@contexts/generateContext';

const [useSearchURL, SearchURLProvider] =
  createGenericContext<SearchViewModel | null>();

export { useSearchURL, SearchURLProvider };
